import { render, staticRenderFns } from "./complateInfo.vue?vue&type=template&id=04df87bc&scoped=true"
import script from "./complateInfo.vue?vue&type=script&lang=js"
export * from "./complateInfo.vue?vue&type=script&lang=js"
import style0 from "./complateInfo.vue?vue&type=style&index=0&id=04df87bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04df87bc",
  null
  
)

export default component.exports